import {
    AfterViewInit,
    Component,
    ComponentRef,
    Input,
    OnInit,
    ViewChild, ViewContainerRef
} from '@angular/core';
import { MoveableBookFeature } from '../../../../models/moveable-book-feature';
import { Page } from '../../../../models/page';
import { PageRectComponent } from './page-rect/page-rect.component';
import { Rect } from '../../../../models/rect';
import { Audio } from '../../../../models/audio';
import { PageAudioComponent } from './page-audio/page-audio.component';
import { PageVideoComponent } from './page-video/page-video.component';
import { Video } from '../../../../models/video';
import { PageLinkComponent } from './page-link/page-link.component';
import { Link } from '../../../../models/link';
import { TextSelection } from '../../../../models/text-selection';
import { PageTextSelectionComponent } from './page-text-selection/page-text-selection.component';
import { ReadspeakerElement } from '../../../../models/readerspeaker-element';
import { PageReadspeakerComponent } from './page-readspeaker/page-readspeaker.component';
import { QuickLink } from '../../../../models/quick-link';
import { PageQuickLinkComponent } from './page-quick-link/page-quick-link.component';
import { WhiteboardDrawingComponent } from './whiteboard-drawing/whiteboard-drawing.component';
import { WhiteboardDrawing } from '../../../../models/whiteboard-drawing';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-book-feature',
    templateUrl: './book-feature.component.html',
    styleUrls: ['./book-feature.component.scss'],
    standalone: true,
    imports: [
        NgStyle
    ]
})
export class BookFeatureComponent implements OnInit, AfterViewInit {

    childHost: ViewContainerRef;

    @ViewChild('childHost', {read: ViewContainerRef})
    set setterChildHost(vcr: ViewContainerRef) {
        if (!vcr) {
            return;
        }

        this.childHost = vcr;
    };
    @Input() moveableBookFeature: MoveableBookFeature | WhiteboardDrawing;
    @Input() page: Page;
    show: boolean;
    isRect: boolean;

    ngOnInit(): void {
        if (this.moveableBookFeature && this.moveableBookFeature.position) {
            this.moveableBookFeature.position.h = this.getHeight();
            this.moveableBookFeature.position.w = this.getWidth();
            this.moveableBookFeature.position.x = this.getX();
            this.moveableBookFeature.position.y = this.getY();
            this.isRect = this.moveableBookFeature instanceof Rect;
        }
    }

    ngAfterViewInit(): void {
        this.loadChildComponent();
    }

    getHeight(): number {
        return Math.min(this.moveableBookFeature.position.h, 100);
    }

    getWidth(): number {
        return Math.min(this.moveableBookFeature.position.w, 100);
    }

    getX(): number {
        return Math.min(this.moveableBookFeature.position.x, 100);
    }

    getY(): number {
        return Math.min(this.moveableBookFeature.position.y, 100);
    }

    private loadChildComponent(): void {
        const component = this.getComponent();

        if (!component) {
            return;
        }

        if (!this.childHost) {
            return;
        }

        this.childHost.clear();
        this.setComponentData(this.childHost.createComponent(component));
    }

    private getComponent(): any {
        if (this.moveableBookFeature instanceof Rect) {
            return PageRectComponent;
        }

        if (this.moveableBookFeature instanceof Audio) {
            return PageAudioComponent;
        }

        if (this.moveableBookFeature instanceof Video) {
            return PageVideoComponent;
        }

        if (this.moveableBookFeature instanceof Link) {
            return PageLinkComponent;
        }

        if (this.moveableBookFeature instanceof TextSelection) {
            return PageTextSelectionComponent;
        }

        if (this.moveableBookFeature instanceof ReadspeakerElement) {
            return PageReadspeakerComponent;
        }

        if (this.moveableBookFeature instanceof QuickLink) {
            return PageQuickLinkComponent;
        }

        if (this.moveableBookFeature instanceof WhiteboardDrawing) {
            return WhiteboardDrawingComponent;
        }

        return undefined;
    }

    private setComponentData(componentRef: ComponentRef<any>): void {

        (componentRef.instance as any).page = this.page;

        if (this.moveableBookFeature instanceof Rect) {
            (componentRef.instance as any).rect = this.moveableBookFeature;
        }

        if (this.moveableBookFeature instanceof Audio) {
            (componentRef.instance as any).audio = this.moveableBookFeature;
        }

        if (this.moveableBookFeature instanceof Video) {
            (componentRef.instance as any).video = this.moveableBookFeature;
        }

        if (this.moveableBookFeature instanceof Link) {
            (componentRef.instance as any).link = this.moveableBookFeature;
        }

        if (this.moveableBookFeature instanceof TextSelection) {
            (componentRef.instance as any).textSelection = this.moveableBookFeature;
        }

        if (this.moveableBookFeature instanceof QuickLink) {
            (componentRef.instance as any).quickLink = this.moveableBookFeature;
        }

        if (this.moveableBookFeature instanceof WhiteboardDrawing) {
            (componentRef.instance as any).whiteboardDrawing = this.moveableBookFeature;
        }
    }
}
